import React, { useContext } from 'react';
import { Mounter } from './mounter';
import { RendererContext as ActionsContext } from '../../RendererActionsContext';
import { useAnnotationRangeDispatch, useAnnotationRangeState } from '../contexts/AnnotationRangeContext';
import { useAnnotationHoverContext } from '../contexts/AnnotationHoverContext';
import { ProvidersContext } from '../context';
export const RangeValidator = props => {
  var _providers$inlineComm, _providers$inlineComm2;
  const {
    component,
    rendererRef,
    applyAnnotationDraftAt,
    clearAnnotationDraft,
    createAnalyticsEvent
  } = props;
  const actions = useContext(ActionsContext);
  const {
    clearHoverRange
  } = useAnnotationRangeDispatch();
  const {
    range,
    type
  } = useAnnotationRangeState();
  const {
    isWithinRange
  } = useAnnotationHoverContext();
  const providers = useContext(ProvidersContext);
  const isCommentsOnMediaBugFixEnabled = (_providers$inlineComm = providers === null || providers === void 0 ? void 0 : providers.inlineComment.isCommentsOnMediaBugFixEnabled) !== null && _providers$inlineComm !== void 0 ? _providers$inlineComm : false;
  const isCommentsOnMediaBugVideoCommentEnabled = (_providers$inlineComm2 = providers === null || providers === void 0 ? void 0 : providers.inlineComment.isCommentsOnMediaBugVideoCommentEnabled) !== null && _providers$inlineComm2 !== void 0 ? _providers$inlineComm2 : false;
  if (!range || type !== 'hover') {
    return null;
  }
  const documentPosition = actions.getPositionFromRange(range, isCommentsOnMediaBugFixEnabled, isCommentsOnMediaBugVideoCommentEnabled);
  return /*#__PURE__*/React.createElement(Mounter, {
    isWithinRange: isWithinRange,
    range: range,
    wrapperDOM: rendererRef,
    component: component,
    onClose: clearHoverRange,
    documentPosition: documentPosition,
    isAnnotationAllowed: true,
    applyAnnotation: actions.applyAnnotation.bind(actions),
    applyAnnotationDraftAt: applyAnnotationDraftAt,
    generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
    clearAnnotationDraft: clearAnnotationDraft,
    createAnalyticsEvent: createAnalyticsEvent
  });
};